import { fetcher } from '@commenda/utils';

export async function unlinkCompanyFromAffiliate(
  affiliateFirmId: string,
  companyId: number,
  userId?: string
) {
  const queryParams = userId ? `?userId=${userId}` : '';
  const response = await fetcher(
    `affiliate-firms/${affiliateFirmId}/company/${companyId}/unlink${queryParams}`,
    {
      method: 'DELETE',
    }
  );

  return response;
}
